import { useEffect, useState } from "react";
import { Plus, Trash2, Hotel, Car } from "lucide-react";
import { Field } from "@/components/PersonCard";
import { stayLists } from "@/lib/api";
import { useApi } from "@/admin/AdminApp";

export const HOTEL_FIELDS = [["city", "City"], ["name", "Hotel name"], ["address", "Address"], ["map_link", "Google Maps link"], ["website", "Website"], ["room", "Room"], ["check_in", "Check-in", "date"], ["check_out", "Check-out", "date"]];
export const TRANSFER_FIELDS = [["city", "City"], ["date", "Date", "date"], ["time", "Time", "time"], ["pickup", "Pick-up location"], ["pickup_map", "Pick-up Google Maps link"], ["vehicle", "Vehicle"], ["cab_number", "Cab ID / registration"], ["driver_name", "Driver name"], ["driver_mobile", "Driver mobile (with country code)"]];

const Entry = ({ kind, item, idx, onChange, onRemove, dir }) => {
  const isHotel = kind === "hotels";
  const list = dir.filter((d) => d.type === (isHotel ? "hotel" : "vehicle"));
  const tid = `${isHotel ? "hotel" : "transfer"}-${idx}`;
  const pick = (id) => { const d = list.find((x) => x.id === id); if (d) onChange({ ...item, ...Object.fromEntries(Object.entries(d.data).filter(([, v]) => v)) }); };
  return (
    <div className="ivory-card p-5" data-testid={`stay-${tid}`}>
      <div className="mb-4 flex items-center justify-between gap-3">
        <span className="eyebrow flex items-center gap-2">{isHotel ? <Hotel size={14} /> : <Car size={14} />}{isHotel ? "Hotel" : "Transfer"} {idx + 1}</span>
        <div className="flex items-center gap-2">
          {list.length > 0 && (
            <select className="input-lux !w-auto !py-1.5 text-sm" value="" onChange={(e) => pick(e.target.value)} data-testid={`${tid}-pick`}>
              <option value="">{isHotel ? "Fill from hotel list\u2026" : "Fill from vehicle list\u2026"}</option>
              {list.map((d) => <option key={d.id} value={d.id}>{isHotel ? `${d.data.name}${d.data.city ? ` \u00b7 ${d.data.city}` : ""}` : `${d.data.cab_number} \u00b7 ${d.data.vehicle || ""} ${d.data.driver_name ? `\u00b7 ${d.data.driver_name}` : ""}`}</option>)}
            </select>
          )}
          <button type="button" onClick={onRemove} className="rounded-full p-2 text-red-700 hover:bg-red-50" data-testid={`${tid}-remove`}><Trash2 size={15} /></button>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {(isHotel ? HOTEL_FIELDS : TRANSFER_FIELDS).map(([k, l, t]) => (
          <Field key={k} label={l}><input type={t || "text"} className="input-lux" value={item[k] || ""} onChange={(e) => onChange({ ...item, [k]: e.target.value })} data-testid={`${tid}-${k}`} /></Field>
        ))}
        {!isHotel && <Field label="Transfer information" className="sm:col-span-2"><textarea className="input-lux min-h-[70px]" value={item.transfer_info || ""} onChange={(e) => onChange({ ...item, transfer_info: e.target.value })} data-testid={`${tid}-transfer_info`} /></Field>}
      </div>
    </div>
  );
};

export default function StayEditor({ stay, onChange }) {
  const api = useApi();
  const [dir, setDir] = useState([]);
  useEffect(() => { api("get", "/directory").then(setDir).catch(() => {}); }, [api]);
  const lists = stayLists(stay);
  const setList = (kind, arr) => onChange({ ...lists, [kind]: arr });
  return (
    <div className="space-y-4" data-testid="stay-editor">
      {["hotels", "transfers"].map((kind) => (
        <div key={kind} className="space-y-3">
          {lists[kind].map((it, i) => (
            <Entry key={i} kind={kind} item={it} idx={i} dir={dir} onChange={(v) => setList(kind, lists[kind].map((x, j) => (j === i ? v : x)))} onRemove={() => setList(kind, lists[kind].filter((_, j) => j !== i))} />
          ))}
        </div>
      ))}
      <div className="flex flex-wrap gap-2">
        <button type="button" className="btn-ghost !py-2 text-sm" onClick={() => setList("hotels", [...lists.hotels, {}])} data-testid="add-hotel-btn"><Plus size={14} /> Hotel</button>
        <button type="button" className="btn-ghost !py-2 text-sm" onClick={() => setList("transfers", [...lists.transfers, {}])} data-testid="add-transfer-btn"><Plus size={14} /> Transfer</button>
      </div>
    </div>
  );
}
